import React from 'react';
import {audioInputFileUpload} from '../../../utilityFunctions/WellnessUtil';

// Global array to store audio chunks during recording
let audioChunks = [];

/**
 * SpeachToText Component
 * 
 * A component that provides speech-to-text functionality by recording audio
 * from the user's microphone and sending it to the server for processing.
 * Includes UI controls for starting and stopping recording.
 * 
 * Note: The variable name has a typo ("Speach" instead of "Speech")
 * but is kept as-is for compatibility with existing code.
 * 
 * @param {Object} props - Component props
 * @param {Object} props.loginUser - User login information including JWT token
 * @returns {JSX.Element} - Rendered UI for speech recording controls
 */
export default function SpeachToText(props) {

    const {loginUser} = props;


    const [mediaRecorder, setMediaRecorder] = React.useState(null);
    // const [audioChunks, setAudioChunks] = React.useState([]);
    const [isRecording, setIsRecording] = React.useState(false);

    /**
     * Starts recording audio from the user's microphone.
     * 
     * Requests microphone access with specific audio settings,
     * initializes a MediaRecorder, sets up event handlers for
     * capturing audio data, and updates component state.
     * 
     * @returns {Promise<void>}
     */
    const startRecording = async () => {

        try {
            
            // Request access to the microphone with specific audio settings
            const stream = await navigator.mediaDevices.getUserMedia({
                audio: {
                    // sampleRate: 16000,      // Use the sample rate of the microphone
                    channelCount: 1,        // Mono audio (1 channel)
                    echoCancellation: true, // Enable echo cancellation
                    noiseSuppression: true, // Enable noise suppression
                },
            });
            
            const recorder = new MediaRecorder(stream);

            recorder.ondataavailable = (event) => {
                console.log("Data available");
                console.log(event.data);
                // setAudioChunks((prevChunks) => [...prevChunks, event.data]);
                audioChunks.push(event.data);
            };

            recorder.start();
            setMediaRecorder(recorder);
            setIsRecording(true);
        } catch (error) {
            console.error("Error accessing microphone:", error);
        }
    };

    /**
     * Stops the recording process and processes the collected audio data.
     * 
     * Stops the MediaRecorder, combines audio chunks into a single blob,
     * creates a FormData object with the audio file, and uploads it to
     * the server for processing.
     * 
     * @returns {Promise<void>}
     */
    const stopRecording = async () => {
        if (mediaRecorder) {
            mediaRecorder.stop();
            setIsRecording(false);

            mediaRecorder.onstop = async () => {
                // Combine chunks into a single Blob (WAV file)
                console.log("Recording stopped");
                console.log(audioChunks);
                const audioBlob = new Blob(audioChunks, { type: "audio/wav" });
                // setAudioChunks([]);
                audioChunks = [];

                // Upload the file to the server
                const formData = new FormData();
                formData.append("audioFile", audioBlob, "audio.wav");

                audioInputFileUpload(formData, loginUser.jwtToken);
            };
        }
    };

    /**
     * Renders the recording control buttons.
     * The buttons are enabled/disabled based on the current recording state.
     */
    return (
        <div>
            <button onClick={startRecording} disabled={isRecording}>
                Start Recording
            </button>
            <button onClick={stopRecording} disabled={!isRecording}>
                Stop Recording
            </button>
        </div>
    );
}
